import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyBoardSwitcherPanel: FunctionComponent = () => {
  const BoardSwitcherPanel = useLazyComponent(
    () =>
      import(/* webpackChunkName: "board-switcher" */ './BoardSwitcherPanel'),
    { namedImport: 'BoardSwitcherPanel' },
  );

  const { value: isBoardSwitcherEnabled } = useFeatureGate(
    'trello_personal_productivity_release',
  );

  if (!isBoardSwitcherEnabled) {
    return null;
  }

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-web-eng',
        feature: 'Board Switcher',
      }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <BoardSwitcherPanel />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
